export const Bank = {
    'KOOKMIN BANK': 'KOOKMIN BANK',
    'HANA BANK': 'HANA BANK'
}
